<template>
  <a-spin :spinning="confirmLoading">
<!--    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">-->
<!--          <a-col :span="24">
            <a-form-model-item label="角色id" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="roleId">
              <a-input v-model="model.roleId" placeholder="请输入角色id"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="应用id" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationId">
              <a-input v-model="model.applicationId" placeholder="请输入应用id"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number v-model="model.sortNo" placeholder="请输入排序" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-input v-model="model.remark" placeholder="请输入备注"  ></a-input>
            </a-form-model-item>
          </a-col>-->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="6" :sm="6">
                <a-form-item :label="language['platform.roleUser.columns.roleName']">
                  <a-input placeholder="" v-model="roleName" disabled="true"></a-input>
                </a-form-item>
              </a-col>
              <a-input placeholder="" v-model="queryParam.roleApplicationCode" hidden="true"></a-input>
              <a-col :md="6" :sm="6">
                <a-form-item :label="language['application.applicationCode']">
                  <a-input :placeholder="language['common.pleaseInput']+language['application.applicationCode']" v-model="queryParam.applicationCode"  allowClear></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="6">
                <a-form-item :label="language['application.applicationName']">
                  <a-input :placeholder="language['common.pleaseInput']+language['application.applicationName']" v-model="queryParam.applicationName"  allowClear></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="language['application.applicationStatus']">
                  <j-dict-select-tag  v-model="queryParam.applicationStatus"  :type="'radio'" dictCode="application_status"/>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="9" :sm="24">
             <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 21px">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>

            </a-col>
          </span>
            </a-row>
          </a-form>
        </div>

          <a-row :gutter="24">
            <a-col :span="14">
              <a-card :title="language['user.apply.list']" :bordered="false" :head-style="{padding:0}" :body-style="{padding:0}">
                <a-table
                  ref="table"
                  size="middle"
                  :scroll="{x:true}"
                  bordered
                  rowKey="id"
                  :columns="columns"
                  :dataSource="dataSource"
                  :pagination="ipagination"
                  :loading="loading"
                  class="j-table-force-nowrap"
                  @change="handleTableChange">

                   <span slot="applicationStatusSlot" slot-scope="text, record, index">
                     <div v-if="text=='1'">{{language['sys.dict.sysportalupdown.unpublish']}}</div>
                     <div v-else-if="text=='0'">{{language['sys.dict.sysportalupdown.publish']}}</div>
                   </span>
                  <span slot="action" slot-scope="text, record, index">
                    <a v-if="!isSelected(record)" @click="handleSelected(record, index)">{{language['common.selectButton']}}</a>
                    <a v-if="isSelected(record)" @click="handleSelectedCancel(record, index)">{{language['depart.management.cancelSelected']}}</a>
                  </span>
              </a-table>
              </a-card>
            </a-col>
            <a-col :span="10">
              <a-card :title="language['common.choosed'] +' '+ language['application']" :bordered="false" :head-style="{padding:0}" :body-style="{padding:0}">
                <a-table
                  ref="table1"
                  size="middle"
                  :scroll="{x:true}"
                  bordered
                  rowKey="id"
                  :columns="columns1"
                  :dataSource="dataSource1"
                  :pagination="false"
                  :loading="loading1"
                  class="j-table-force-nowrap"
                  @change="handleTableChange">

                   <span slot="action" slot-scope="text, record, index">
                    <a @click="handleDeleteSelected(record, index)">{{language['common.delete']}}</a>
                   </span>
                </a-table>
              </a-card>
            </a-col>
          </a-row>
<!--      </a-form-model>
    </j-form-container>-->
  </a-spin>
</template>

<script>

  import { httpAction, getAction, postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: 'EmpRoleApplicationForm',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      roleId: String,
      roleName: String,
      roleApps: {
        type: Array,
        default: () => []
      },
      roleApplicationCode: String,
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           roleId: [
              { required: true, message: '请输入角色id!'},
           ],
           applicationId: [
              { required: true, message: '请输入应用id!'},
           ],
        },
        url: {
          add: "/hhemp/presets/emproleapplication",
          edit: "/hhemp/presets/emproleapplication",
          queryById: "/hhemp/presets/emproleapplication/",
          list: "/sys/portal/sysPortalOrg/getAllAppsContainThird",//?applicationStatus=1
          list2: "/hhemp/presets/roleApps",
        },
        dataSource: [],
        dataSource1: [],
        searchApplicationCode: "",
        disableMixinCreated: true,
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
      columns(){
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
            title: this.language['application.applicationName'],
            align: 'center',
            dataIndex: 'applicationName',
            width: 120,
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
            {
              title:  this.language['application.applicationCode'],
              align: "center",
              width: 100,
              dataIndex: 'applicationCode',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.language['application.applicationStatus'],
              align: "center",
              width: 80,
              dataIndex: 'applicationStatus',
              scopedSlots: {customRender: 'applicationStatusSlot'}
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              scopedSlots: { customRender: 'action' },
              align: 'center',
              width: 80
            }]

        }
      },

      columns1(){
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
            title: this.language['application.applicationName'],
            align: 'center',
            dataIndex: 'applicationName',
            width: 120,
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              scopedSlots: { customRender: 'action' },
              align: 'center',
              width: 80
            },
           ]

        }
      },

    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.queryParam.roleApplicationCode = this.roleApplicationCode;
      this.loadApplications();
      /*if(this.roleApps!=undefined&&this.roleApps!=null){
        this.dataSource1 = this.roleApps;
      }*/
      this.loadRoleApps();
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;

        var apps = this.dataSource1.map((item,index)=>{return item.id}).join(',');

        postAction('/hhemp/presets/emproleapps', {
          roleId: this.roleId,
          selectedApps: apps,
        }).then(function (res) {
          if (res.success) {
            that.$message.success(that.language["operationSuccess"]);
            that.submitCallback();
            that.confirmLoading = false;
          } else {
            that.$message.error(res.message);
          }
        });

      },

      loadApplications() {
        this.loading = true;
        let formPara = {
          roleApplicationCode: this.roleApplicationCode,
        }
        getAction(this.url.list, formPara).then(res => {
          if (res.success) {
            const result = res.result;
            this.dataSource = result;
          } else {
            this.$message.warning(res.message);
          }
        }).finally(() => {
          this.loading = false;
        });
      },

      handleSelected(item){
        this.dataSource1.push(item);
      },
      handleSelectedCancel(item){
        const index = this.dataSource1.findIndex((record) => record.id === item.id);
        if (index !== -1) {
          this.dataSource1.splice(index, 1);
        }
      },
      handleDeleteSelected(item){
        const index = this.dataSource1.findIndex((record) => record.id === item.id);
        if (index !== -1) {
          this.dataSource1.splice(index, 1);
        }
      },
      isSelected(item){
        const index = this.dataSource1.findIndex((record) => record.id === item.id);
        if (index !== -1) {
          return true;
        }else{
          return false;
        }
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      loadRoleApps(){
        //this.loading1 = true;
        let formPara = {
          roleId: this.roleId,
        }
        getAction(this.url.list2, formPara).then(res => {
          if (res.success) {
            const result = res.result;
            this.dataSource1 = result;
          } else {
            this.$message.warning(res.message);
          }
        }).finally(() => {
          //this.loading1 = false;
        });
      },

      searchReset() {
        this.queryParam = {}
        this.queryParam.roleApplicationCode = this.roleApplicationCode;
        this.loadData(1);
      },


    }
  }
</script>
